(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();
	var documentHeight = $(document).height();

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = 60;

	$(window).scroll(function(event){
	    didScroll = true;
	});

	setInterval(function() {
	    if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 250);

	function hasScrolled() {
	    var st = $(this).scrollTop();
	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta)
	        return;

	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
	    if (st > lastScrollTop && st > navbarHeight){
	        // Scroll Down
	        $('html').addClass('fixed');
					$('html').removeClass('scrolled');
	    } else {
	        // Scroll Up
	        if(st < lastScrollTop) {
						$('html').addClass('scrolled');
	          $('html').addClass('animation');
	        }
					if (st<150) {
						$('html').removeClass('scrolled fixed animation');
					}
	    }
	    lastScrollTop = st;
	}


	/* Document ready functions */
	$(document).ready(function (){


	});

	$(window).resize(function () {


	});

})(jQuery);
